import { withInstall } from '../../../utils/with-install'
import ThreeVideo from './ThreeVideo.vue'

export const ElAmapThreeVideo = withInstall(ThreeVideo)
export default ElAmapThreeVideo
